import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Telegram = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 40.578H10a10 10 0 0 1-10-10v-20a10 10 0 0 1 10-10h20a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10Z"
      fill="#199BDF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 11.828H30A5.625 5.625 0 0 0 30.575.607c-.191-.01-.38-.029-.575-.029H10a10 10 0 0 0-10 10v20a18.75 18.75 0 0 1 18.75-18.75"
      fill="#32B4FF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 20.578a10 10 0 1 0 10 10v-20a10 10 0 0 1-10 10Z"
      fill="#0082BE"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.175 11.223a1.874 1.874 0 0 1 2.569 2.018L27.97 31.265a1.874 1.874 0 0 1-2.965 1.225 84011.47 84011.47 0 0 1-8.176-6.025 1.25 1.25 0 0 1-.117-1.915l7.63-7.205a.313.313 0 0 0-.386-.489l-10.086 6.578a3.749 3.749 0 0 1-2.958.497L6.18 22.748a1.25 1.25 0 0 1-.174-2.368l22.169-9.157Z"
      fill="#fff"
    />
  </Svg>
)

export default Telegram
